import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Verification';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.6168 8.3662C13.8881 8.05318 13.8543 7.57951 13.5412 7.30823C13.2282 7.03695 12.7546 7.07079 12.4833 7.3838L9.1108 11.2751L7.88037 10.0447C7.58747 9.75178 7.1126 9.75178 6.81971 10.0447C6.52681 10.3376 6.52681 10.8124 6.81971 11.1053L8.61971 12.9053C8.76692 13.0525 8.96871 13.1319 9.17677 13.1245C9.38483 13.1171 9.58045 13.0235 9.7168 12.8662L13.6168 8.3662Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.125 17.25C11.8224 17.25 13.3811 16.6565 14.605 15.6656L19.7197 20.7803C20.0126 21.0732 20.4874 21.0732 20.7803 20.7803C21.0732 20.4874 21.0732 20.0126 20.7803 19.7197L15.6656 14.605C16.6565 13.3811 17.25 11.8224 17.25 10.125C17.25 6.18997 14.06 3 10.125 3C6.18997 3 3 6.18997 3 10.125C3 14.06 6.18997 17.25 10.125 17.25ZM10.125 15.75C13.2316 15.75 15.75 13.2316 15.75 10.125C15.75 7.0184 13.2316 4.5 10.125 4.5C7.0184 4.5 4.5 7.0184 4.5 10.125C4.5 13.2316 7.0184 15.75 10.125 15.75Z" fill="currentColor"/>
  </svg>
`;

const VerificationIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M13.6168 8.3662C13.8881 8.05318 13.8543 7.57951 13.5412 7.30823C13.2282 7.03695 12.7546 7.07079 12.4833 7.3838L9.1108 11.2751L7.88037 10.0447C7.58747 9.75178 7.1126 9.75178 6.81971 10.0447C6.52681 10.3376 6.52681 10.8124 6.81971 11.1053L8.61971 12.9053C8.76692 13.0525 8.96871 13.1319 9.17677 13.1245C9.38483 13.1171 9.58045 13.0235 9.7168 12.8662L13.6168 8.3662Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.125 17.25C11.8224 17.25 13.3811 16.6565 14.605 15.6656L19.7197 20.7803C20.0126 21.0732 20.4874 21.0732 20.7803 20.7803C21.0732 20.4874 21.0732 20.0126 20.7803 19.7197L15.6656 14.605C16.6565 13.3811 17.25 11.8224 17.25 10.125C17.25 6.18997 14.06 3 10.125 3C6.18997 3 3 6.18997 3 10.125C3 14.06 6.18997 17.25 10.125 17.25ZM10.125 15.75C13.2316 15.75 15.75 13.2316 15.75 10.125C15.75 7.0184 13.2316 4.5 10.125 4.5C7.0184 4.5 4.5 7.0184 4.5 10.125C4.5 13.2316 7.0184 15.75 10.125 15.75Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: VerificationIcon,
  IconSvg: IconSvg
} as IconType;
